import { useEffect, useState } from 'react';
import "./index.css";

const donate = () => {
  const [redirectCountdown, setRedirectCountdown] = useState(5);

  useEffect(() => {
    // Set countdown timer
    const countdownInterval = setInterval(() => {
      setRedirectCountdown((prev) => prev - 1);
    }, 1000);

    // Redirect after 5 seconds
    const redirectTimer = setTimeout(() => {
      window.location.replace('https://pages.razorpay.com/aswa');
    }, 5000);

    // Cleanup timers on unmount
    return () => {
      clearInterval(countdownInterval);
      clearTimeout(redirectTimer);
    };
  }, []);

  const handleDonateClick = () => {
    window.location.href = "https://pages.razorpay.com/aswa";
  };

  return (
    <div className="donate-page">
      <div className="rounded-box">
        <h2>Important Disclaimer</h2>
        <p>You will be redirected to the designated ASWA Razorpay Payment Page (Gateway). Upon successful donation, you will be redirected back to aswa4u.org.</p>
        <br />
        <p style={{ textAlign: 'center' }}>Redirecting in <strong>{redirectCountdown}</strong> seconds...</p>
        <br />
        <p>If you are not redirected automatically, click below button.</p>
        <br />
        <button onClick={handleDonateClick} className="ok-button">
          ASWA Razorpay Payment Gateway
        </button>
        <div style={{ textAlign: 'center' }}>
          <img 
            src="/Images/razorpay.svg" 
            alt="Payment" 
            style={{ margin: '15px auto 0px', maxWidth: '90px', borderRadius: '10px' }} 
          /> 
        </div>
      </div>      
    </div>
  );
};

export default donate;
